export default "__VITE_ASSET__na4hmSrC__"